import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "13",
  height: "15",
  viewBox: "0 0 13 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon--svg icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0.583252 14.2916V0.75H7.33L7.66333 2.41667H12.2499V9.91663H7.16979L6.83646 8.24996H1.83323V14.2916H0.583252Z" }, null, -1)
  ])))
}
export default { render: render }